import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Recolte } from '../../models/recolte.model';

@Injectable({ providedIn: 'root' })
export class RecolteService {

  private readonly base = `${environment.BASE_URL}/api/recoltes`;

  constructor(private http: HttpClient) {}

  getByCulture(cultureId: number): Observable<Recolte[]> {
    return this.http.get<Recolte[]>(this.base, { params: { cultureId } });
  }

  getByFerme(fermeId: number): Observable<Recolte[]> {
    return this.http.get<Recolte[]>(this.base, { params: { fermeId } });
  }

  create(dto: Recolte): Observable<Recolte> {
    return this.http.post<Recolte>(this.base, dto);
  }

  update(id: number, dto: Partial<Recolte>): Observable<Recolte> {
    return this.http.put<Recolte>(`${this.base}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }

  lierRevenu(recolteId: number, montant: number, modePaiement: string): Observable<Recolte> {
    return this.http.post<Recolte>(`${this.base}/${recolteId}/revenu`, { montant, modePaiement });
  }
}
